export default __webpack_public_path__ + "static/logo-398c4c181d321ca49ba42e325257cd44.svg";